import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((_) => ({
  imageContainer: {
    width: "80%",
    height: "200px",
    marginInline: "auto",
    marginBlock: "1rem",
    position: "relative",
  },
  imagePreview: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "1rem",
  },
  deleteButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
}));

function SelectedFiles({ media, type, handleDelete }) {
  const classes = useStyles();

  return (
    <>
      {type === "Image" ? (
        <Box className={classes.imageContainer}>
          <img src={media} alt="preview" className={classes.imagePreview} />
          <IconButton
            className={classes.deleteButton}
            onClick={() => handleDelete()}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ) : type === "Video" ? (
        <Box className={classes.imageContainer}>
          <video width="100%" height="200px" controls crossorigin="anonymous">
            <source src={media.src} type="video/mp4" />
            Your browser does not support the video tag
          </video>
          <IconButton
            className={classes.deleteButton}
            onClick={() => handleDelete()}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ) : (
        media.map((item, index) => {
          if (item.type === "Image") {
            return (
              <Box className={classes.imageContainer} key={index}>
                <img
                  src={item.file}
                  alt="preview"
                  className={classes.imagePreview}
                />
                <IconButton
                  className={classes.deleteButton}
                  onClick={() => handleDelete(item.file)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          } else {
            return (
              <Box className={classes.imageContainer} key={index}>
                <video
                  width="100%"
                  height="200px"
                  controls
                  crossorigin="anonymous"
                >
                  <source src={item.file.src} type="video/mp4" />
                  Your browser does not support the video tag
                </video>
                <IconButton
                  className={classes.deleteButton}
                  onClick={() => handleDelete(item.file.src)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          }
        })
      )}
    </>
  );
}

export default SelectedFiles;
